<template>
    <b-container fluid>
        <h2>{{ msg }}</h2>
        <hr size=1>
        <b-container>
        <b-row>
          <b-col>1</b-col>
          <b-col>2</b-col>
          <b-col>3</b-col>
          <b-col>4</b-col>
          <b-col>5</b-col>
          <b-col>6</b-col>
          <b-col>7</b-col>
          <b-col>8</b-col>
          <b-col>9</b-col>
          <b-col>10</b-col>
          <b-col>11</b-col>
          <b-col>12</b-col>
        </b-row>
        <b-row>
          <b-col>
            <font-awesome-icon icon="user-secret" />
          </b-col>
          <b-col>
            <font-awesome-icon icon="key" />
          </b-col>
          <b-col>
            <font-awesome-icon icon="mask" />
          </b-col>
        </b-row>
        </b-container>

    </b-container>
</template>

<script>
/* eslint-disable */

var data = {
  msg: 'Bootstrap Vue Test Page'
}

export default {
  name: 'BootstrapVue',
  data () { return data }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col {
    border: 1px solid #CCC;
}
</style>


// WEBPACK FOOTER //
// src/components/BootstrapVue.vue